// 管理员专属路由:未登录跳登录,非管理员跳回我的仓库
import { Navigate, useLocation } from 'react-router-dom';
import { ReactNode } from 'react';
import { useAuthStore } from '@/store/auth';
import { ROUTES } from '@/routes';

export function AdminRoute({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const accessToken = useAuthStore((s) => s.accessToken);
  const location = useLocation();

  if (!accessToken || !user) {
    return <Navigate to={ROUTES.login} state={{ from: location.pathname }} replace />;
  }
  if (!user.is_admin) {
    return <Navigate to={ROUTES.dashboard} replace />;
  }
  return <>{children}</>;
}
